<div class="vox-card sms-fraud-limits-section mb-4 mb-sm-0">
  <div *ngIf="(smsRateLimits$ | async) && !(loading$ | async)?.rateLimit">
    <div class="spread-items mb-2">
      <span class="vox-heading-3" translate>companies.sms.fraud-limit.title</span>
      <button *ngIf="!(failed$ | async)?.rateLimit" container="body" placement="left"
        [ngbTooltip]="'companies.sms.fraud-limit.edit' | translate" class="vox-btn vox-btn-icon" (click)="editSmsRateLimits()"> <i
          class="icon-small-edit"></i> </button>
      <button *ngIf="(failed$ | async)?.rateLimit" container="body" placement="left" (click)="loadSmsRateLimits()"
        [ngbTooltip]="'companies.sms.fraud-limit.re-try' | translate" class="vox-btn vox-btn-icon"> <i
          class="icon-small-update"></i> </button>
    </div>
    <div class="spread-items">
      <div>
        <span class="vox-heading-6" translate>companies.sms.fraud-limit.account-rate</span><br>
        <span class="d-none d-sm-inline" translate>companies.sms.fraud-limit.account-rate-info</span>
      </div>
      <div>
        <span *ngIf="(failed$ | async)?.rateLimit" class="vox-heading-6" translate>companies.sms.fraud-limit.na</span>
        <span *ngIf="!(failed$ | async)?.rateLimit" class="vox-heading-6 d-none d-sm-inline" [innerHTML]="'companies.sms.fraud-limit.rates' | translate: {requests: (smsRateLimits$ | async)?.company_rate_limit.requests, time: (smsRateLimits$ | async)?.company_rate_limit?.per_seconds}"></span>
        <span *ngIf="!(failed$ | async)?.rateLimit" class="vox-heading-6 d-inline d-sm-none" [innerHTML]="'companies.sms.fraud-limit.rate' | translate: {requests: (smsRateLimits$ | async)?.company_rate_limit.requests, time: (smsRateLimits$ | async)?.company_rate_limit?.per_seconds}"></span>
      </div>
    </div>
    <div class="spread-items mt-3">
      <div>
        <span class="vox-heading-6" translate>companies.sms.fraud-limit.identical-rate</span><br>
        <span class="d-none d-sm-inline" translate>companies.sms.fraud-limit.identical-rate-info</span>
      </div>
      <div>
        <span *ngIf="(failed$ | async)?.rateLimit" class="vox-heading-6" translate>companies.sms.fraud-limit.na</span>
        <span *ngIf="!(failed$ | async)?.rateLimit" class="vox-heading-6 d-none d-sm-inline" [innerHTML]="'companies.sms.fraud-limit.rates' | translate: {requests: (smsRateLimits$ | async)?.content_rate_limit.requests, time: (smsRateLimits$ | async)?.content_rate_limit?.per_seconds}"></span>
        <span *ngIf="!(failed$ | async)?.rateLimit" class="vox-heading-6 d-inline d-sm-none" [innerHTML]="'companies.sms.fraud-limit.rate' | translate: {requests: (smsRateLimits$ | async)?.content_rate_limit.requests, time: (smsRateLimits$ | async)?.content_rate_limit?.per_seconds}"></span>
      </div>
    </div>
  </div>
  <div *ngIf="(loading$ | async)?.rateLimit">
    <div class="spread-items">
      <ngx-skeleton-loader [theme]="{ 'height': '32px','width': '140px', 'margin-bottom': '10px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '32px', 'width': '40px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
    <div class="spread-items">
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '140px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '140px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
    <div class="spread-items">
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '280px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
    <div class="spread-items">
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '140px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '140px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
    <div class="spread-items">
      <ngx-skeleton-loader [theme]="{ 'height': '12px', 'width': '280px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>
    </div>
  </div>
  <div class="spread-items mt-3">
    <div>
      <span class="vox-heading-6" translate>companies.sms.fraud-limit.fraud-lock</span><br>
    </div>
    <div>
      <button *ngIf="(failed$ | async)?.smsConfig &&  !(loading$ | async)?.smsConfig" (click)="loadSmsConfig()" container="body" placement="left"
        [ngbTooltip]="'company.users.include-users.re-try' | translate" class="vox-btn vox-btn-icon btn-update"> <i
          class="icon-small-update"></i> </button>
      <vox-toggle *ngIf="!(failed$ | async)?.smsConfig" [loading]="(loading$ | async)?.smsConfig" [toggleOn]="fraudLockEnabled$ | async"
        [config]="{isAquamarine: true}" (click)="onFraudLockChange($event)">
      </vox-toggle>
    </div>
  </div>
</div>